import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from '../TaskDetails.style';
import {TaskDetailsContent} from '../TaskDetailsContent';

export const DayOneCheckInDetails = () => {
  const {ts} = useTranslation(
    'clientProfile.clientJourney.firstWeek.dayOneCheckIn',
  );

  return (
    <>
      <View style={styles.taskDetailContent}>
        <Text
          variant="button"
          style={styles.taskDetailContentText}
          {...testProperties(DownlineProfile.cjTaskDetailsBulletsHeaderText)}>
          {ts(
            'details',
            'Your Client may be feeling excited and nervous. So on your call, you should:',
          )}
        </Text>
      </View>
      <TaskDetailsContent
        taskDetailsList={[
          ts(
            'detailsListItem1',
            'Ask about any challenges or areas of confusion so that you can provide support.',
          ),
          ts(
            'detailsListItem2',
            'Remind your Client of their why(s) from the Health Assessment.',
          ),
          ts(
            'detailsListItem3',
            'Celebrate your Client’s commitment and make sure they have what they need to be successful tomorrow - establish trust, rapport and accountability.',
          ),
        ]}
        style={{
          base: styles.listItemContainer,
          listItem: styles.listItem,
        }}
      />
    </>
  );
};
